import { clarity } from "react-microsoft-clarity";

export function initializeClarity() {
  const clarityId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  clarity.init(clarityId);
}
export function setCustomUserID(user, id) {
  const userId = `${user.name}-${id}`;
  clarity.setTag("userId", userId);
  clarity.setTag("name", user.name);
  clarity.setTag("email", user.email);
}
